import Vue from 'vue'

export default {
  name: 'RawHtml',
  props: {
    template: {
      type: String,
      default: () => undefined,
    },
    isRte: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      templateRender: null,
    }
  },
  render() {
    //render(h) {
    if (!this.templateRender) {
      // return h('div', 'loading...')
      return undefined
    } else {
      // If there is a template, I'll show it
      return this.templateRender()
    }
  },
  watch: {
    // Every time the template prop changes, I recompile it to update the DOM
    template: {
      immediate: true, // makes the watcher fire on first render, too.
      handler() {
        if (this.template) {
          let res

          if (this.isRte) {
            res = Vue.compile(`<div class="rte">${this.template}</div>`)
          } else {
            res = Vue.compile(this.template)
          }

          this.templateRender = res.render

          // staticRenderFns belong into $options,
          // appearantly
          this.$options.staticRenderFns = []

          // clean the cache of static elements
          // this is a cache of the results from the staticRenderFns
          this._staticTrees = []

          // Fill it with the new staticRenderFns
          for (const i in res.staticRenderFns) {
            // staticRenderFns.push(res.staticRenderFns[i]);
            this.$options.staticRenderFns.push(res.staticRenderFns[i])
          }
        }

        return undefined
      },
    },
  },
}
